const operationLogCollections = {
  subsidiaries: { label: '会社', },
  accountItems: { label: '勘定科目', },
  consolidationAccountItems: { label: '連結科目', },
  consolidationJournalTypes: { label: '仕訳種別', },
  consolidationSegments: { label: '連結セグメント', },
  sections: { label: '部門', },
  exchangeRates: { label: '為替レート', },
  cfAccountItems: { label: 'CF科目', },
  cfChangeTypes: { label: 'CF増減種別', },
  linkingRules: { label: '自動マッチングルール', },
  roleTemplates: { label: '権限テンプレート', },
  periodSettings: { label: '期設定', },
  presetConsolidationAccountItemSettings: { label: 'プリセット連結科目設定', },
  disclosureAccountItemMappings: { label: '開示科目マッピング', },
  disclosureSettings: { label: '開示設定', },
};

const legacyOperationLogModels = {
  ipRestrictionSetting: { label: 'IPアドレス制限', },
};

const operationLogTypes = {
  create: { label: '作成', color: 'success', },
  update: { label: '更新', color: 'info', },
  delete: { label: '削除', color: 'danger', },
};

const operationLogAuthTypes = {
  service_account: { label: 'システム', },
  system: { label: 'システム', },
  api_key: { label: 'ユーザー', },
  unauthenticated: { label: '未認証', },
  unknown: { label: '不明', },
};

// 画面から createOperationLog で書かれた旧形式(modelName/payload/createdBy)のうち operationType が create/update/delete のものを新形式に揃える
const normalizeOperationLog = (log) => {
  if(log.collection != null) return log;

  return {
    ...log,
    collection: log.modelName,
    before: log.payload?.prevData || null,
    after: log.payload?.data || null,
    authId: log.createdBy?.id || null,
    authDisplayName: log.createdBy?.displayName || log.createdBy?.email || null,
  };
};

const operationLogTargetLabel = (collection) => (operationLogCollections[collection] || legacyOperationLogModels[collection])?.label || collection;

exports.operationLogCollections = operationLogCollections;
exports.operationLogTypes = operationLogTypes;
exports.operationLogAuthTypes = operationLogAuthTypes;
exports.normalizeOperationLog = normalizeOperationLog;
exports.operationLogTargetLabel = operationLogTargetLabel;
